module.exports = __webpack_public_path__ + "media/הצגה.47bca9aa.mp3";